import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReferralsTable from '../../referrals/ReferralsTable';

interface Props {
    matterId?: string;
}

const ReferralsView: React.FC<Props> = ({ matterId }) => {
    if (!matterId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <h5 className="text-h5">
                <FormattedMessage id={'referrals.titles.matter'} />
            </h5>
            <ReferralsTable passiveFilter={`id=isreferralmatter=${matterId}`} matterId={matterId} />
        </div>
    );
};

export default ReferralsView;
